import { useAuth } from 'hooks/useAuth'
import { rules as defaultRules } from './rules'
import { useSocketQueryBridge } from './useSocketQueryBridge'
import type { InvalidationRule } from './types'

/**
 * Headless component that bridges Socket.IO events to React Query cache
 * invalidation for the platform-user surfaces (provider + operation). Mount
 * once per authenticated layout (ProviderLayout, OperationLayout). Renders
 * nothing.
 *
 * Uses the provider/admin JWT from `useAuth()` as the socket principal. Pass a
 * custom `rules` set to extend/override which events map to which query keys
 * (defaults to the shared provider/ops rules). The customer portal, which
 * authenticates a different principal, uses `CustomerSocketQueryBridge`.
 */
export function SocketQueryBridge({ rules = defaultRules }: { rules?: InvalidationRule[] } = {}) {
  const { token } = useAuth()
  useSocketQueryBridge(token, rules)
  return null
}
